import React from 'react'
import { IconFileDownload } from '@tabler/icons-react'

export const KodiArtifactMessage = ({ message }) => {
  return (
    <div className="cowork-artifact-message">
      <IconFileDownload size={16} />
      <span className="cowork-artifact-message__filename">{message.filename}</span>
      <span className="cowork-artifact-message__status">Downloaded</span>
    </div>
  )
}
